<template lang='pug'>
div
  v-container
    v-row
      v-col(
        cols='1'
        sm='1'
        md='4'
        lg='3'
        xl='4'
      )
      v-col(
        cols='10'
        sm='10'
        md='4'
        lg='6'
        xl='4'
      )
        v-file-input(
          accept='image/*'
          @change='fileParse'
          prepend-icon='mdi-image'
          label='Upload'
        )
      v-col(
        cols='1'
        sm='1'
        md='4'
        lg='3'
        xl='4'
      )
    v-row
      v-col(
        v-for='documentSnapshot in documentSnapshots'
        :key='documentSnapshot.get("downloadUrl")'
        cols='6'
        sm='4'
        md='4'
        lg='3'
        xl='2'
      )
        v-card(
          :disabled='isDeleted[documentSnapshot.id]'
        )
          v-img(
            :src='documentSnapshot.get("downloadUrl")'
          )
          v-card-actions
            v-spacer
            v-btn(
              icon
              :href='documentSnapshot.get("downloadUrl")'
              target='_blank'
            )
              v-icon mdi-magnify
            v-btn(
              v-if='documentSnapshot.get("href")'
              icon
              :href='documentSnapshot.get("href")'
              target='_blank'
            )
              v-icon mdi-link
            v-btn(
              icon
              @click='deleteWithDocumentSnapshot(documentSnapshot)'
            )
              v-icon mdi-delete
</template>

<script>
/* eslint-disable no-unused-vars */
/* eslint-disable no-unexpected-multiline */

import {
  app,
} from '@thomasphan/vue-components/src/functions/initializeApp';

import {
  getUid,
} from '@thomasphan/vue-components/src/functions/getUid';

import {
  addDoc,
  collection,
  getFirestore,
  deleteDoc,
  getDocs,
  updateDoc,
} from 'firebase/firestore';

import {
  listAll,
  getStorage,
  ref as refStorage,
  getDownloadURL,
  deleteObject,
} from 'firebase/storage';

import { fileToDownloadUrl } from '../functions/fileToDownloadUrl';
import { each, fromPairs, get, includes, invoke, map, pipe, placeholder, reverse, set, sortBy, tap } from 'lodash/fp';
import { computed, ref, onMounted } from 'vue';

const db = getFirestore(app);

const setup = function ()
{
  const downloadUrlToTimestamp = downloadUrl => downloadUrl.match(/(\d+)\.?[a-z]*\?/)[1];
  const downloadUrlToFileName = downloadUrl => downloadUrl.match(/(\d+\.?[a-z]*)\?/)[1];
  const documentSnapshotToTimestamp = documentSnapshot => downloadUrlToTimestamp(documentSnapshot.get('downloadUrl'));
  const documentSnapshotToFileName = documentSnapshot => downloadUrlToFileName(documentSnapshot.get('downloadUrl'));
  const storageReferenceToTimestamp = storageReference => storageReference.name.match(/\d+/)[0];

  const storage = getStorage();

  const documentSnapshots = ref([]);
  const isDeleted = ref({});

  const deleteWithDocumentSnapshot = async function (documentSnapshot)
  {
    const uid = await getUid();

    const fileName = downloadUrlToFileName(documentSnapshot.get('downloadUrl'));

    const storageReference = refStorage(storage, `images/${uid}/${fileName}`);

    await deleteDoc(documentSnapshot.ref);
    await deleteObject(storageReference);

    isDeleted.value = {
      ...isDeleted.value,
      [documentSnapshot.id]: true,
    };
  };

  const getCollectionReference = async function ()
  {
    const uid = await getUid();
    return collection(db, 'users', uid, 'items');
  };

  const getDocumentSnapshots = async function ()
  {
    const collectionReference = await getCollectionReference();

    const querySnapshot = await getDocs(collectionReference);

    documentSnapshots.value = pipe([
      sortBy(pipe([documentSnapshotToTimestamp, window.Number])),
      reverse,
    ])(querySnapshot.docs);
  };

  const fileParse = async function (file)
  {
    const collectionReference = await getCollectionReference();

    await window
    .Promise
    .resolve(file)
    .then(fileToDownloadUrl)
    .then(downloadUrl => addDoc(collectionReference, { downloadUrl }));

    await getDocumentSnapshots();
  };

  onMounted(async function ()
  {
    await getDocumentSnapshots();

    /* {
      const uid = await getUid();

      const timestampToDocumentSnapshot = pipe([
        map(documentSnapshot => [documentSnapshotToTimestamp(documentSnapshot), documentSnapshot]),
        fromPairs,
      ])(documentSnapshots.value);

      const collectionReference = await getCollectionReference();

      const storageReference = refStorage(storage, `images/${uid}`);

      const listResult = await listAll(storageReference);

      for (const storageReference of listResult.items) {
        if (!timestampToDocumentSnapshot[storageReferenceToTimestamp(storageReference)]) {
          // await addDoc(collectionReference, { downloadUrl: await getDownloadURL(storageReference) });
        }
      }

      const timestampToDownloadUrl = await Promise
      .resolve(listResult.items)
      .then(map(async storageReference => [storageReferenceToTimestamp(storageReference), await getDownloadURL(storageReference)]))
      .then(result => Promise.all(result))
      .then(fromPairs);

      each(documentSnapshot => {
        const timestamp = downloadUrlToTimestamp(documentSnapshot.get('downloadUrl'));
        // updateDoc(documentSnapshot.ref, { downloadUrl: timestampToDownloadUrl[timestamp] });
      })(documentSnapshots.value);
    } */
  });

  return {
    documentSnapshots,
    deleteWithDocumentSnapshot,
    fileParse,
    isDeleted,
  };
};

export default
{
  setup,
  name: 'Home',
};
</script>
